import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as locations from '../../../../constants/dropdown';
import {messageTextValidation, nameValidation, emailValidation, phoneValidation, locationValidation} from '../../../../utils/itemValidation';

import * as commonActionCreators from '../../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

import RhinoSelect from '../../../common/inputs/RhinoSelect';

class InfluenceMeganrunionmcr extends React.Component {

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    const firstEntryNotReq = [{display: 'Location*', 'value': ''}];
    const finalEntry = [{display: 'Other', 'value': 'online@diamondsdirect.com'}];
    let newArray= firstEntryNotReq.concat(locations.locations).concat(finalEntry);

    this.state = {
      locations: newArray,
      inputName: '',
      inputEmail: '',
      inputPhone: '',
      inputLocation: '',
      inputMessage: '',
      inputDesigner: '',
      designerLocation: '',
      errorName: null,
      errorEmail: null,
      errorPhone: null,
      errorLocation: null,
      errorMessage: null,
      errorDesigner: null,
      errorDesignerLocation: null,
    };
  }

  componentDidMount() {

  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  changeName(evt) {
    this.setState({ inputName: evt.target.value }, () => {
      if(this.state.errorName && !nameValidation(this.state.inputName)) {
        this.setState({ errorName: null });
      }
    });
  }

  changeEmail(evt) {
    this.setState({ inputEmail: evt.target.value }, () => {
      if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
        this.setState({ errorEmail: null });
      }
    });
  }

  changePhone(evt) {
    this.setState({ inputPhone: evt.target.value }, () => {
      if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
        this.setState({ errorPhone: null });
      }
    });
  }

  changeLocation(evt) {
    this.setState({ inputLocation: evt.target.value}, () => {
      if(this.state.errorLocation !== false && this.state.inputLocation !== '') {
        this.setState({errorLocation: null});
      }
    });
  }

  submitContactRequest() {
    if(this.validateAll()) {

      let contactData = {
        full_name: this.state.inputName,
        email: this.state.inputEmail,
        phone: this.state.inputPhone,
        location: this.state.inputLocation,
      }

      console.log(this.props);
      this.props.commonSummerContactRequest(contactData);
      this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
      this.setState({
        inputName: '',
        inputEmail: '',
        inputPhone: '',
        inputLocation: '',
        inputDesigner: '',
        errorName: null,
        errorEmail: null,
        errorPhone: null,
        errorLocation: null,
      });
    }
  }

  validateAll() {

    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let emailError = emailValidation(this.state.inputEmail);
    let locationError = locationValidation(this.state.inputLocation);

    // Optional params
    let phoneError = null;
    if(this.state.inputPhone) {
      phoneError = phoneValidation(this.state.inputPhone);
    }

    if(nameError === null &&
       emailError === null &&
       phoneError === null &&
       locationError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorEmail: emailError,
      errorPhone: phoneError,
      errorLocation: locationError,
    }, () => {
      console.log(this.state);
    });

    return !hasErrors;
  }

  render() {
    return <div className={'InfluenceMeganrunionmcr InfluencePage'}>
      <div className='ipHeader'>
        <img className='desktopHeader' src="https://ddw2.diamondsdirect.com/img/influence/mr/text/mr_banner.jpg" alt="Diamonds Direct" />
        <img className='mobileHeader' src="https://ddw2.diamondsdirect.com/img/influence/mr/text/mr_banner_m.jpg" alt="Diamonds Direct" />

        <div className={'overlayLink linkH1 desktopLink'} onClick={() => this.internalNav('jewelry/PRL9N00122')}></div>
        
        <div className={'overlayLink linkH1m mobileLink'} onClick={() => this.internalNav('jewelry/PRL9N00122')}></div>

      </div>

      <div className='ipBody'>
        <div className={'ipRow ipRow1'}>
          <img className='desktopRow' src='https://ddw2.diamondsdirect.com/img/influence/mr/text/mr_1.jpg' alt='Diamonds Direct' />
          <img className='mobileRow' src='https://ddw2.diamondsdirect.com/img/influence/mr/text/mr_m_1.jpg' alt='Diamonds Direct' />

          <div className={'overlayLink link11 desktopLink'} onClick={() => this.internalNav('jewelry/EHOOP00498')}></div>
          <div className={'overlayLink link12 desktopLink'} onClick={() => this.internalNav('band/BLDLG00689')}></div>
          <div className={'overlayLink link14 desktopLink'} onClick={() => this.internalNav('jewelry/GBANG00545')}></div>
          
          <div className={'overlayLink link11m mobileLink'} onClick={() => this.internalNav('jewelry/EHOOP00498')}></div>

        </div>
        <div className={'ipRow ipRow2'}>
          <img className='desktopRow' src='https://ddw2.diamondsdirect.com/img/influence/mr/text/mr_2.jpg' alt='Diamonds Direct' />
          <img className='mobileRow' src='https://ddw2.diamondsdirect.com/img/influence/mr/text/mr_m_2.jpg' alt='Diamonds Direct' />

          <div className={'overlayLink link21 desktopLink'} onClick={() => this.internalNav('jewelry/TB10000258')}></div>
          <div className={'overlayLink link22 desktopLink'} onClick={() => this.internalNav('diamond-pendants')}></div>
          <div className={'overlayLink link23 desktopLink'} onClick={() => this.internalNav('diamond-studs')}></div>
          <div className={'overlayLink link24 desktopLink'} onClick={() => this.internalNav('jewelry/EHOOP01005')}></div>

          <div className={'overlayLink link21m mobileLink'} onClick={() => this.internalNav('jewelry/GBANG00545')}></div>
          <div className={'overlayLink link23m mobileLink'} onClick={() => this.internalNav('band/BLDLG00689')}></div>

        </div>
        <div className={'ipRow ipRow3'}>
          <img className='mobileRow' src='https://ddw2.diamondsdirect.com/img/influence/mr/text/mr_m_3.jpg' alt='Diamonds Direct' />

          <div className={'overlayLink link31m mobileLink'} onClick={() => this.internalNav('jewelry/TB10000258')}></div>
          <div className={'overlayLink link32m mobileLink'} onClick={() => this.internalNav('diamond-pendants')}></div>
          <div className={'overlayLink link33m mobileLink'} onClick={() => this.internalNav('diamond-studs')}></div>

        </div>
        <div className={'ipRow ipRow4'}>
          <img className='mobileRow' src='https://ddw2.diamondsdirect.com/img/influence/mr/text/mr_m_4.jpg' alt='Diamonds Direct' />

          <div className={'overlayLink link41m mobileLink'} onClick={() => this.internalNav('jewelry/EHOOP01005')}></div>

        </div>
      </div>

      <div className='ipCustom'>
        <div className='customTitleWrapper'>
          <div className='customTitle'>Custom Jewelry Creation</div>
        </div>
        <div className='customBody'>We'd love to work with you to create the perfect piece! Book an appointment today to make your ideas come to life with a diamond expert.</div>
      </div>

      <div className='ipForm'>
        <div className='formInnerWrapper'>
          
          <div className='formP'>Prefer to shop in person? Walk-in visits are always welcome! But, if you’d like to set up an appointment online or in store, please use the form below and we will follow up to confirm!</div>

          <div className='formWrapper'>
            <div className='formInputWrapper'>
              <input 
                className={this.state.errorName ? 'textInput error' : 'textInput'}
                type='text' 
                placeholder='Full Name*'
                value={this.state.inputName}
                        onChange={::this.changeName} />
            </div>
            <div className='formInputWrapper'>
              <input 
                className={this.state.errorEmail ? 'textInput error' : 'textInput'}
                type='email' 
                placeholder='Email Address*'
                value={this.state.inputEmail}
                        onChange={::this.changeEmail} />
            </div>
            <div className='formInputWrapper'>
              <input 
                className={this.state.errorPhone ? 'textInput error' : 'textInput'}
                type='text' 
                placeholder='Telephone'
                value={this.state.inputPhone}
                        onChange={::this.changePhone} />
            </div>
            <div className='formInputWrapper'>
              <RhinoSelect
                selectClass={'influenceSelect'}
                required={true}
                value={this.state.inputLocation}
                options={this.state.locations}
                changeMethod={(evt) => this.changeLocation(evt)}
                error={this.state.errorLocation !== null} />
            </div>
            <div className='formActionRow'>
              <button className={'formAction'} onClick={::this.submitContactRequest}>Request an appointment</button>
            </div>
          </div>
        </div>
      </div>
    </div>;
  }
}
export default InfluenceMeganrunionmcr;

function mapStateToProps(state) {
  return {

  };
}

export const InfluenceMeganrunionmcrContainer = connect(
  mapStateToProps,
  allActionCreators
)(InfluenceMeganrunionmcr);


// WEBPACK FOOTER //
// ./src/components/views/influencers/pages/InfluenceMeganrunionmcr.jsx